import React, { useState } from "react";
import { Eye, Copy, Check, CheckCircle2 } from "lucide-react";

export function CredRow({ label, value, subValue, testId, onCopy, isPassword, big }) {
  const [reveal, setReveal] = useState(false);
  const [copied, setCopied] = useState(false);
  const displayed = isPassword && !reveal ? "•".repeat(Math.min(12, (value || "").length || 8)) : value;

  const handleCopy = async () => {
    await onCopy(value, `${label} copiado`);
    setCopied(true);
    setTimeout(() => setCopied(false), 1600);
  };

  return (
    <div className="flex items-center gap-2 p-2 rounded-xl bg-black/40 border border-zinc-800">
      <div className="flex-1 min-w-0">
        <p className="text-[10px] uppercase tracking-widest text-zinc-500 font-mono">{label}</p>
        <p className={`font-mono font-bold text-white truncate ${big ? "text-lg" : "text-sm"}`} data-testid={testId}>
          {displayed}
        </p>
        {subValue && (
          <p
            data-testid={`${testId}-subvalue`}
            className="mt-0.5 text-[11px] font-bold text-emerald-300 truncate flex items-center gap-1"
            title={subValue}
          >
            <CheckCircle2 className="w-3 h-3 flex-shrink-0" />
            <span className="truncate">{subValue}</span>
          </p>
        )}
      </div>
      {isPassword && (
        <button data-testid="cred-row-button-1"
          type="button"
          onClick={() => setReveal(!reveal)}
          className="p-2 rounded-lg bg-zinc-800 hover:bg-zinc-700 text-zinc-300"
          title={reveal ? "Ocultar" : "Mostrar"}>
          <Eye className="w-4 h-4" />
        </button>
      )}
      <button
        type="button"
        onClick={handleCopy}
        data-testid={`${testId}-copy-btn`}
        className={`px-3 py-2 rounded-lg text-xs font-bold flex items-center gap-1.5 transition-all ${copied ? "bg-green-600 text-white" : "bg-cyan-600 hover:bg-cyan-500 text-white"}`}
      >
        {copied ? <><Check className="w-3.5 h-3.5" /> Copiado</> : <><Copy className="w-3.5 h-3.5" /> Copiar</>}
      </button>
    </div>
  );
}
